import axios from "axios";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "http://localhost:5000/api",
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});


const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop().split(";").shift();
  }
  return null;
};

axiosInstance.interceptors.request.use(
  (config) => {
    const adminAuthToken = getCookie("adminAuthToken");
    const authToken = getCookie("authToken");
    // console.log("%c adminAuthToken: ", "background: #ffff00; color: #000000; font-weight: bold;", adminAuthToken);
    // console.log("%c authToken: ", "background: #00ff04ff; color: #000000ff; font-weight: bold;", authToken);
    if (adminAuthToken) {
      config.headers.adminAuthToken = adminAuthToken;
    }
    if (authToken) {
      config.headers.authToken = authToken;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          console.error("Unauthorized access - please login again");
          // window.location.href = '/login';
          break;
        case 403:
          console.error("Forbidden - insufficient permissions");
          break;
        case 404:
          console.error("Resource not found");
          break;
        case 500:
          console.error("Internal server error");
          break;
        default:
          console.error("An error occurred:", error.response.data);
      }
    } else if (error.request) {
      console.error("No response received from server");
    } else {
      console.error("Error setting up request:", error.message);
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
